import { EditorView } from "@codemirror/view"

/**
 * Extension to handle keyboard events and prevent them from bubbling to window.
 * This prevents window-level event listeners from capturing keyboard events
 * that should be handled only by the editor.
 */
export const keyboardHandler = EditorView.domEventHandlers({
  keydown(event: KeyboardEvent) {
    // Stop event from bubbling to window
    event.stopPropagation()
    // Let CodeMirror handle the keyboard event normally
    return false
  },
  
  keyup(event: KeyboardEvent) {
    // Stop event from bubbling to window
    event.stopPropagation()
    // Let CodeMirror handle the keyboard event normally
    return false
  },
  
  keypress(event: KeyboardEvent) {
    // Stop event from bubbling to window
    event.stopPropagation()
    // Let CodeMirror handle the keyboard event normally
    return false
  },
})

